import * as R from 'ramda';
import angular from 'angular';

export default function SyncRiskTypeDialogController(
  $q,
  $rootScope,
  $scope,
  ssDialogService,
  confirmDialog,
  alerts,
  riskDataService,
  loaderService, // eslint-disable-line no-unused-vars
  syncRiskConfirmDialog,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSyncRisks = _handleSyncRisks;
  vm.handleCheckAllChange = _handleCheckAllChange;
  vm.isEditable = true;
  vm.handleClearFilters = _handleClearFilters;
  vm.showFilters = true;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    vm.searchText = '';
    vm.risks = [];
    if (vm.riskType.customerRisks && vm.riskType.customerRisks.length > 0) {
      angular.forEach(vm.riskType.customerRisks, (risk) => {
        if (!risk.isSynced) {
          risk.riskType = vm.riskType;
          vm.risks.push(angular.copy(risk));
        }
      });
    }

    $scope.$on('refreshSyncRisks', (event, opt) => {
      _updateRiskList(opt.customerRiskId);
    });
    $scope.$on('selectSyncControlChange', () => {
      _handleSyncRiskChange();
    });
    vm.filteredAssets = vm.assets;
  }

  function _handleSyncRiskChange() {
    const selectedIds = [];
    R.forEach((item) => {
      if (item.isSyncSelected === true) {
        selectedIds.push(item.customerRiskId);
      }
    }, vm.risks);
    vm.selectAll = selectedIds.length === vm.risks.length;
  }

  function _handleClearFilters() {
    vm.searchText = '';
  }

  function _handleCheckAllChange() {
    R.forEach(
      (risk) => {
        risk.isSyncSelected = vm.selectAll;
      },
      vm.risks
    );
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleSyncRisks($event) {
    const _risks = [];
    R.forEach(
      (item) => {
        if (item.isSyncSelected === true) {
          _risks.push(item);
        }
      },
      vm.risks
    );
    if (_risks.length > 0) {
      ssDialogService.dialogs.riskAdmin.syncRiskDialog = ssDialogService.alert(
        syncRiskConfirmDialog.getOptions($event, {
          risks: _risks,
          riskType: vm.riskType,
          isMultipleRisks: true,
          updateCallBack: _broadcastEvents,
        })
      );

      ssDialogService.show(ssDialogService.dialogs.riskAdmin.syncRiskDialog);
    }
  }

  function _broadcastEvents() {
    $rootScope.$broadcast('refreshRiskType', { riskType: vm.riskType });
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.riskAdmin.syncRiskTypeDialog);
  }

  function _updateRiskList(existingRiskId) {
    angular.forEach(vm.risks, (risk, index) => {
      if (existingRiskId === risk.customerRiskId) {
        vm.risks.splice(index, 1);
      }
    });
  }
}

SyncRiskTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'ssDialogService',
  'confirmDialog',
  'alerts',
  'riskDataService',
  'loaderService',
  'syncRiskConfirmDialog',
];
